import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { settings } from './domain/app-settings';
import { AuthResp, ReadBasePecInfoResp, ReadPecResp, TextLogoResp, VerifyLinkResp } from './models';


const defaultHttpOptions = {
  headers: new HttpHeaders({
    // sending token to server
    Accept: 'application/json, text/plain',
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class HttpClientService {
  footer= {}
  private baseUrl = settings().apiBaseUrl;

  constructor(private http: HttpClient) {
  }

  verifyLink(token: string): Observable<VerifyLinkResp> {
    return this.http.get<VerifyLinkResp>(this.baseUrl + '/verify/' + token, defaultHttpOptions);
  }

  createPecos(token: string): Observable<AuthResp> {
    return this.http.post<AuthResp>(this.baseUrl + '/create/pecos/' + token, defaultHttpOptions);
  }

  auth(token: string,
       cfPiva: string,
       conditionOneAccepted: boolean): Observable<AuthResp> {
    const authReq = {cfPiva, conditionOneAccepted};
    return this.http.post<AuthResp>(this.baseUrl + '/authenticate/' + token, authReq, defaultHttpOptions);
  }

  retrieveTextAndLogo(token: string): Observable<TextLogoResp> {
    return this.http.get<TextLogoResp>(this.baseUrl + '/retrieveLogoAndTexts/' + token, defaultHttpOptions);
  }

  readPecContent(token: string): Observable<ReadPecResp> {
    const httpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/json, text/plain',
        'Content-Type': 'application/json',
        // sending token to server
        Authorization: localStorage.getItem('auth-token')
      })
    };
    return this.http.get<ReadPecResp>(this.baseUrl + '/readPec/' + token, httpOptions);
  }

  downloadEnvelop(token: string): Observable<string> {
    const httpOptions = {
      responseType: 'base64',
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('auth-token')
      })
    };
    // @ts-ignore
    return this.http.get(this.baseUrl + '/download/attachment/' + token + '/envelope/1', httpOptions);
  }

  downloadFile(token: string, attachmentId: string, filename: string): Observable<string> {
    const httpOptions = {
      responseType: 'base64',
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('auth-token')
      })
    };
    // @ts-ignore
    return this.http.get(this.baseUrl + '/download/attachment/' + token + '/file/' + attachmentId, httpOptions);
  }

  retrieveMailInfo(token: string): Observable<ReadBasePecInfoResp>{
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('auth-token')
      })
    };
    // @ts-ignore
    return this.http.get(`${this.baseUrl}/readBasePecInfo/${token}`, httpOptions);
  }
}
